/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useTheme } from 'emotion-theming';
import ScrollBar from 'react-scrollbars-custom';
import { migratoryWebCitizen, phytosanitaryWeb, sanitarianRegistersWeb, tdCarWeb } from '../../Colors';
import style from './dropDownNotification.style';
import { CloseIcon, ExclamationCircleIcon, NotificationsCircleIcon } from '../../../icon';
const themes = {
  migratoryWebCitizen: {
    alpha: migratoryWebCitizen.botticelli,
    beta: migratoryWebCitizen.cerulean
  },
  sanitarianRegistersWeb: {
    alpha: sanitarianRegistersWeb.botticelli,
    beta: sanitarianRegistersWeb.cerulean
  },
  phytosanitaryWeb: {
    alpha: phytosanitaryWeb.mantis
  },
  tdCarWeb: {
    alpha: tdCarWeb.botticelli,
    beta: tdCarWeb.cerulean
  }
};
/**
 * This component represent a drop down of notifications.
 * @param {string} notificationsCount Notification count.
 * @param {JSON} notifications Dropdown items.
 * @param {function} onClick Function triggered when the user clicks the dropdown notification.
 */

const DropDownNotification = /*#__PURE__*/React.memo(({
  notificationsCount,
  notifications,
  onClick,
  customStyle
}) => {
  const {
    theme
  } = useTheme();
  const [display, setDisplay] = React.useState(false);

  const NotificationsList = ({
    data
  }) => {
    let current = {
      date: '',
      dayOfWeek: ''
    };
    let showTitle = false;
    const today = format(new Date(), 'dd/MM/yyyy');
    return data === null || data === void 0 ? void 0 : data.map((notification, index) => {
      const date = format(new Date(notification.createdAt), 'dd/MM/yyyy');
      const dayOfWeek = format(new Date(notification.createdAt), 'EEEE', {
        locale: es
      });

      if (index === 0) {
        current = {
          date,
          dayOfWeek
        };
      }

      if (current.date !== date) {
        current = {
          date,
          dayOfWeek
        };
        showTitle = true;
      } else {
        showTitle = false;
      }

      if (current.date === today) {
        current = { ...current,
          date: `HOY - ${current.dayOfWeek}`
        };
      }

      return jsx("div", {
        key: `notifications-${index.toString()}`
      }, (showTitle || index === 0) && jsx("div", {
        className: "notification-date"
      }, current.date), jsx("div", {
        className: "notification-info",
        role: "button",
        onClick: () => {
          onClick(notification.id);
        },
        tabIndex: 0
      }, jsx("div", {
        className: "notification-header row"
      }, jsx("div", {
        className: "column",
        style: {
          width: '10%'
        }
      }, jsx(ExclamationCircleIcon, {
        css: {
          width: 18,
          height: 18,
          color: themes[theme].alpha,
          marginTop: 2
        }
      })), jsx("div", {
        className: "header-title column",
        style: {
          width: '50%'
        }
      }, notification.title), jsx("div", {
        className: "header-hour column",
        style: {
          width: '20%'
        }
      }, format(new Date(notification.createdAt), 'h:mm aa'))), jsx("div", {
        className: "row",
        style: {
          marginLeft: 15
        }
      }, jsx("div", {
        className: "column",
        style: {
          width: '10%'
        }
      }), jsx("div", {
        className: "notification-message column",
        style: {
          width: '70%'
        }
      }, notification.message))));
    });
  };

  return jsx("div", {
    css: style,
    style: customStyle
  }, jsx("div", {
    className: "dropdown"
  }, jsx("div", null, jsx("div", {
    className: "notifications-count"
  }, jsx("p", {
    style: {
      marginTop: 6
    }
  }, notificationsCount)), jsx(NotificationsCircleIcon, {
    css: {
      width: 32,
      height: 32,
      color: themes[theme].alpha,
      marginTop: 10,
      marginLeft: 15,
      marginRight: 15
    },
    onClick: () => {
      setDisplay(true);
    }
  })), jsx("div", {
    className: "dropdown-icon"
  }, jsx("div", {
    className: "dropdown-content",
    style: {
      display: display ? 'flex' : 'none'
    }
  }, jsx("div", {
    className: "title"
  }, jsx("span", null, "NOTIFICACIONES"), jsx(CloseIcon, {
    css: {
      width: 17,
      height: 17,
      color: themes[theme].beta,
      float: 'right',
      marginTop: 10,
      marginLeft: 10,
      marginRight: 36,
      marginBottom: 10
    },
    onClick: () => {
      setDisplay(false);
    }
  })), jsx(ScrollBar, {
    style: {
      height: '100%'
    }
  }, jsx(NotificationsList, {
    data: notifications
  }))))));
});
export default DropDownNotification;